// extracted by mini-css-extract-plugin
export default {"modalContent":"DeactivateClientModal_modalContent__MpaIE","actionInfo":"DeactivateClientModal_actionInfo__7xE9p"};